import React from "react";

export default function AssignDrawer({
  open,
  paper = null,
  metaDataOptions = {},

  operationValue = "",
  employeeValue = "",

  onOperationChange,
  onEmployeeChange,
  
  onSubmit,
  onClose,
}) {
  if (!open) return null;
//  console.log("AssignDrawer props - paper:", operationValue, employeeValue);
  const operationOptions = [
    { value: "3", label: "Review" },
    { value: "9", label: "ProofReading" }
  ];

  const employeeOptions =
    operationValue === "3"
      ? metaDataOptions.ReviewersOptions || []
      : operationValue === "9"
        ? metaDataOptions.createdByOptions || []
        : [];

  return (
    <>
      <button
        type="button"
        className="paper-comments-backdrop"
        onClick={onClose}
        aria-label="Close assign"
      />

      <aside className={`paper-comments-drawer ${open ? "open" : ""}`} aria-hidden={!open}>
        <div className="paper-comments-drawer__header">
          <div>
            <span>Assign Paper</span>
            <strong>{paper?.code}</strong>
          </div>
          <button className="paper-assign-close" onClick={onClose} aria-label="Close assign">×</button>
        </div>

        <div className="paper-comments-drawer__body">
          <div className="paper-assign-details mb-3">
            <h6 className="mb-3">Paper Details</h6>

            <p><strong>Title:</strong> {paper?.name || "N/A"}</p>

            <p>
              <strong>Operation Status:</strong>{" "}
              {paper?.status || "N/A"}
              {/* {paper?.operationStatusText ? ` ${paper.operationStatusText}` : ""} */}
            </p>

            <p><strong>Assigned Employee:</strong> {paper?.assignedTo || "N/A"}</p>

            <p><strong>Assigned By:</strong> {paper?.assignedBy || "N/A"}</p>

            <p><strong>Created By:</strong> {paper?.createByName || "N/A"}</p>

            <p>
              <strong>Created At:</strong>{" "}
              {paper?.createdAt
                ? new Date(`${paper.createdAt}Z`).toLocaleString()
                : "N/A"}
            </p>
          </div>

          <label className="form-label">Select Operation</label>
          <select className="form-control"
            value={operationValue}
            onChange={(e) => onOperationChange(e.target.value)}>
            <option value="">Select Operation</option>
            {operationOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>

          <label className="form-label mt-3">Select Employee</label>
          <select className="form-control" value={employeeValue} onChange={(e) => onEmployeeChange(e.target.value)}>
            <option value="">Select Employee</option>
            {employeeOptions.map((opt) => {
              const userCode = opt?.meta?.user_code || '';
              const first = opt?.meta?.first_name || opt?.meta?.firstname || opt?.meta?.firstName || '';
              const last = opt?.meta?.last_name || opt?.meta?.lastname || opt?.meta?.lastName || '';
              const fullName = [first, last].filter(Boolean).join(' ');
              const display = userCode ? `${userCode} - ${fullName || opt.label}` : `${opt.value} - ${opt.label}`;
              return (
                <option key={opt.value} value={opt.value}>{display}</option>
              );
            })}
          </select>


          <div className="mt-3 d-flex gap-2">
            <button type="button" className="btn btn-primary" onClick={onSubmit}>Assign</button>
            <button type="button" className="btn btn-secondary" onClick={onClose}>Close</button>
          </div>
        </div>
      </aside>
    </>
  );
}
